import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { toastr } from "react-redux-toastr";
import { toggleSwitch, translateProps } from "MODULES/shared/decorators";
import { ConfirmAction, Icon, DropDownItem } from "MODULES/shared/components";
import api from "APP_ROOT/api";
import _ from "lodash";

function Unreceive({ unreceive, unreceiving, open, close }) {
  return (
    <DropDownItem onClick={open}>
      <Icon name="undo" fixed />
      <span className="with-padding">Unreceive</span>
      <ConfirmAction onConfirm={unreceive} close={close} open={unreceiving}>
        <strong>Heads up! </strong>
        <span className="with-padding">
          Are you sure you want to unreceive this record?
        </span>
      </ConfirmAction>
    </DropDownItem>
  );
}

Unreceive.propTypes = {
  close: T.func.isRequired,
  open: T.bool.isRequired,
  unreceive: T.func.isRequired,
  unreceiving: T.bool.isRequired
};

const withUnreceive = translateProps(
  ({ receivingRecord, close, pushHistory }) => ({
    unreceive: () =>
      api.receivingRecord
        .unreceive(receivingRecord.get("id"))
        .then(() => {
          pushHistory({ pathname: "/receiving" });
          close();
        })
        .catch(error => {
          toastr.error("Error", _.get(error, "errors.base[0]"));
        })
  })
);

const unreceive = toggleSwitch("unreceiving")(withUnreceive(Unreceive));

export default connect(undefined, { pushHistory: push })(unreceive);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Unreceive/Unreceive.jsx